// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteGroup, getAllGroups, getGroup, getGroupsKPI, updateGroup } from '../../helpers/backend_helper';
import { fetchGroupsFailure, fetchGroupsKpiFailure, fetchGroupsKpiSuccess, fetchGroupsSuccess, openEditGroupPageSuccess, updateGroupFailure, updateGroupSuccess } from './actions';
import { deleteGroupFailure, deleteGroupSuccess, fetchGroupFailure, fetchGroupSuccess } from '../actions';
import { DELETE_GROUPS_REQUEST, FETCH_GROUPS_REQUEST, FETCH_GROUP_REQUEST, KPI_GROUPS_REQUEST, OPEN_EDIT_GROUP_PAGE, UPDATE_GROUPS_REQUEST } from './actionTypes';

import { reduxSerializedError } from '../../utils/utils'; //update token on call API

function* fetchGroupsSaga() {
  try {
    const response = yield call(getAllGroups);
    
    yield put(fetchGroupsSuccess(response.data));
  } catch (error) {
    yield put(fetchGroupsFailure(reduxSerializedError(error)));
  }
}

function* fetchGroupSaga({ payload }) {
  try {
    const response = yield call(getGroup, payload);
    yield put(fetchGroupSuccess(response));
  } catch (error) {
    yield put(fetchGroupFailure(reduxSerializedError(error)));
  }
}

function* deleteGroupsSaga({ payload }) {
  try {
    yield call(deleteGroup, payload);
    yield put(deleteGroupSuccess(payload));
    yield call(fetchGroupsSaga); // Refresh the user list
  } catch (error) {
    yield put(deleteGroupFailure(reduxSerializedError(error)));
  }
}

function* updateGroupSaga({ payload }) {
  const { group, navigate } = payload;
  try {
    yield call(updateGroup, group);
    navigate(`/groups`);
    yield put(updateGroupSuccess());
    yield call(fetchGroupsSaga); // Refresh the user list
  } catch (error) {
    yield put(updateGroupFailure(reduxSerializedError(error)));
  }
}

function* openEditPageSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/groups/${id}`);
    yield put(openEditGroupPageSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}

function* fetchGroupsKpiSaga() {
  try {
    const response = yield call(getGroupsKPI);
    yield put(fetchGroupsKpiSuccess(response));
  } catch (error) {
    yield put(fetchGroupsKpiFailure(reduxSerializedError(error)));
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_GROUPS_REQUEST, fetchGroupsSaga);
  yield takeEvery(FETCH_GROUP_REQUEST, fetchGroupSaga);
  yield takeEvery(UPDATE_GROUPS_REQUEST, updateGroupSaga);
  yield takeEvery(DELETE_GROUPS_REQUEST, deleteGroupsSaga);
  yield takeEvery(OPEN_EDIT_GROUP_PAGE, openEditPageSaga);
  yield takeEvery(KPI_GROUPS_REQUEST, fetchGroupsKpiSaga);
}
